module.exports = __webpack_public_path__ + "img/currency.1df473cc.svg";